goog.provide("shadow.js.shim.module$$mui$material$LinearProgress$default");
shadow.js.shim.module$$mui$material$LinearProgress$default = shadow.js.shim.module$$mui$material$LinearProgress.default;
